// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelDisabled-Title_cls1__KUpmt","cls2":"PaymentChannelDisabled-Title_cls2__i5PJy PaymentChannelDisabled-Title_cls1__KUpmt"};